import { parse } from 'node-html-parser'
import Vue from 'vue'

window.quickshop = (handle, event) => {
  fetch(`/products/${ handle }?view=quickshop`)
    .then(response => response.text())
    .then(data => {
      let html = parse(data)
      document.querySelector('.app__modal-content').innerHTML = ''
      document.querySelector('.app__modal-content').insertAdjacentHTML('afterbegin', html.querySelector('.product'))
      window.PSVueProduct = new Vue({
        name: 'QuickshopProduct',
        el: '.app__modal',
        comments: true,
        components: {
          'quantity'   : require('../Vue/Components/Quantity.vue').default,
          'installment': require('../Vue/Components/Installment.vue').default
        },
        mounted () {
          window.init_tiny_sliders()
          window.PStemplates.loadProduct()
          this.$actions.toggleModal()
        }
      })
    })
    event.preventDefault()
}
